import { render, staticRenderFns } from "./UserProjectTab.vue?vue&type=template&id=5d270bd2&"
import script from "./UserProjectTab.vue?vue&type=script&lang=js&"
export * from "./UserProjectTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports